export default __webpack_public_path__ + "static/media/yosemite.5a0d3d29.jpg";